export default {
  badge: 'Badge',
  close: 'Luk',
  dataIterator: {
    noResultsText: 'Fandt ingen matchende elementer.',
    loadingText: 'Henter elementer...',
  },
  dataTable: {
    itemsPerPageText: 'Rækker per side:',
    ariaLabel: {
      sortDescending: 'Sorteret faldende.',
      sortAscending: 'Sorteret stigende.',
      sortNone: 'Ikke sorteret.',
      activateNone: 'Aktiver for at fjerne sortering.',
      activateDescending: 'Aktiver for at sortere faldende.',
      activateAscending: 'Aktiver for at sortere stigende.',
    },
    sortBy: 'Sorter efter',
  },
  dataFooter: {
    itemsPerPageText: 'Elementer per side:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Næste side',
    prevPage: 'Forrige side',
    firstPage: 'Første side',
    lastPage: 'Sidste side',
    pageText: '{0}-{1} af {2}',
  },
  datePicker: {
    itemsSelected: '{0} valgt',
  },
  noDataText: 'Ingen data tilgængelig',
  carousel: {
    prev: 'Forrige billede',
    next: 'Næste billede',
    ariaLabel: {
      delimiter: 'Karruselbillede {0} af {1}',
    },
  },
  calendar: {
    moreEvents: '{0} flere',
  },
  fileInput: {
    counter: '{0} filer',
    counterSize: '{0} filer ({1} total)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
}
